var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google_map"},[_c('v-container',{attrs:{"fluid":true}},[_c('GmapMap',{staticStyle:{"height":"500px","width":"100%"},attrs:{"center":{lat:10,lng:10},"zoom":7}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }